import moment from "moment/min/moment-with-locales";
import { useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import DataDescription from "../DataDescription";
import { DashboardPanel, DescriptionWithDownloadRow } from "../pageSections";
import useSortableData from "../useSortableData";
import ScheduleCheckHourSummaryHeader from "./ScheduleCheckHourSummaryHeader";
import ScheduleCheckHourSummaryRow from "./ScheduleCheckHourSummaryRow";

export default function ScheduleCheckHourTable({ data, submittedFormData }) {
    const { sortedItems, requestSort, sortConfig } = useSortableData(data);

    const csvHeaders = ["Hour", "Dropped songs", "Added songs"];
    const csvData = useMemo(
        () => sortedItems?.map(x => [`${moment(x.hour_from, "H").format("LT")} - ${moment(x.hour_from, "H").endOf("hour").format("LT")}`, x.removed, x.added]),
        [sortedItems]
    );

    return (
        <DashboardPanel>
            <DashboardPanel.Title>Hour Summary</DashboardPanel.Title>
            <div className=" px-4">
                <DescriptionWithDownloadRow csvHeaders={csvHeaders} data={csvData} filename="Schedule Check Hour Summary">
                    <DataDescription>
                        <DataDescription.Station radioId={submittedFormData.station[0].radio_id} />
                        <DataDescription.Date date={submittedFormData.date} />
                        <DataDescription.HourRange startHour={submittedFormData.hourRange[0]} endHour={submittedFormData.hourRange[1]} />
                    </DataDescription>
                </DescriptionWithDownloadRow>
            </div>
            <DashboardPanel.DataContent>
                <ScheduleCheckHourSummaryHeader requestSort={requestSort} sortConfig={sortConfig} />
                <Container fluid>
                    <Row className=" row-cols-1 row-cols-xl-2">
                        <Col className="border-bottom border-bottom-xl-0">
                            {sortedItems.slice(0, 12).map(x => (
                                <ScheduleCheckHourSummaryRow key={x.hour_from} item={x} />
                            ))}
                        </Col>
                        <Col className="border-start-xl">
                            {sortedItems.slice(12, 24).map(x => (
                                <ScheduleCheckHourSummaryRow key={x.hour_from} item={x} />
                            ))}
                        </Col>
                    </Row>
                </Container>
            </DashboardPanel.DataContent>
        </DashboardPanel>
    );
}
